const YTPlayer = require('yt-player')

export function popupYouTube() {
  const popupYouTube = document.querySelector('.js-popup-youtube');
  const popupYouTubeClose = document.querySelectorAll('.js-popup-youtube-close');
  const trigger = document.querySelectorAll('.js-popup-youtube-trigger');
  let player = '';
  if(trigger && popupYouTube) {
    for(let i = 0; i < trigger.length; i++) {
      const el = trigger[i];
      el.addEventListener('click', function(e) {
        const ytid = el.getAttribute('data-youtube-id');
        player = new YTPlayer('.js-popup-youtube-element', {
          playsInline: true,
          related: false
        });
        popupYouTube.classList.add('is-active');
        player.load(ytid);
        setTimeout(() => {
          player.play();
          popupYouTube.querySelector('.js-popup-youtube-container').classList.add('is-active');
        }, 1200);
        e.preventDefault();
      })
    }
  }
  if(popupYouTubeClose) {
    for(let i = 0; i < popupYouTubeClose.length; i++) {
      const el = popupYouTubeClose[i];
      el.addEventListener('click', function(e) {
        player.mute();
        popupYouTube.classList.remove('is-active');
        popupYouTube.querySelector('.js-popup-youtube-container').classList.remove('is-active');
        setTimeout(() => {
          player.stop();
          player.destroy();
        }, 600);
        e.preventDefault();
      })
    }
  }
}